import Branch from '@/lib/Branch';
import Section from '@/lib/Section';
import {Question} from '@/lib/Question';
import Condition from '@/lib/Condition';
import store from '../store';

export default class Step {
    public ranking: number = 0;
    public sections: Section[] = [];
    public isValid = false;
    public isBlank = false;
    constructor(public id: number, public title: string, public description: string = '', public branch: Branch|null = null, public wide: boolean = false, public iconName: string = '', public hotReload = false) {
    }

    public displayAdditionalButton() {
        const currentQuestion: Question = store.state.currentBranch.currentQuestion;
        const currentQuestionIsLastOfSection = currentQuestion.isLastOfSection();
        const currentSectionIsLastOfStep = currentQuestion.section.isLastOfStep();
        const stepHasMultipleSections = !!this.multipleSection();

        return currentQuestionIsLastOfSection && currentSectionIsLastOfStep && stepHasMultipleSections;
    }
    public multipleSection() {
        return this.sections.find((section: Section) => section.multiple);
    }


    public validate() {

        this.isValid = this.sections.every(
            (section: Section) => {
                section.conditions.forEach((condition: Condition) => condition.check());
                const sectionCanDisplay = section.canDisplay();
                if (!sectionCanDisplay || section.arraySectionIds.length) {
                    return true;
                }
                const canDisplay = section.questions.filter((question: Question) => question.canDisplay());

                return canDisplay.every((question: Question) => {
                    // console.log(question.label+' '+question.stepValidation())
                    return question.stepValidation();
                });
            },
        );
        this.isBlank = this.sections.every(
            (section: Section) => {
                section.conditions.forEach((condition: Condition) => condition.check());
                const sectionCanDisplay = section.canDisplay();
                if (!sectionCanDisplay || section.arraySectionIds.length) {
                    return true;
                }
                const canDisplay = section.questions.filter((question: Question) => question.canDisplay());

                return canDisplay.every((question: Question) => {
                    return !question.required && question.currentResponseIsEmpty();
                });
            },
        );
    }
}
